<template>
  <!-- Owner of a backup item: opens the current client when it exists now,
       otherwise offers to open the restore workspace of the backup client. -->
  <div class="bk-cref">
    <div class="bk-cref__name">
      <a v-if="hasCurrent" href="#" class="no-click" v-b-tooltip.hover.top="$t('backup.openCurrentClient')"
         @click.prevent.stop="showClient(currentClientId)">{{ name || `#${clientBackupId}` }}</a>
      <span v-else>{{ name || `#${clientBackupId}` }}</span>
    </div>
    <div class="bk-cref__sub">
      <span class="bk-id">{{ $t('backup.backupShort') }} #{{ clientBackupId }}</span>
      <span v-if="hasCurrent" class="bk-id bk-id--current">→ #{{ currentClientId }}</span>
      <button v-else-if="clientKnown !== false" type="button" class="bk-cref__missing no-click"
              v-b-tooltip.hover.top="$t('backup.restoreClientFirstHint')"
              @click.stop="$emit('open-workspace', clientBackupId)">
        <i class="fa-solid fa-user-plus"></i> {{ $t('backup.restoreClientFirst') }}
      </button>
    </div>
  </div>
</template>

<script>
import mixinBase from '@/components/mixin/mixinBase'

export default {
  name: 'BackupClientRef',
  mixins: [mixinBase],
  props: {
    name: { type: String, default: null },
    clientBackupId: { default: null },
    currentClientId: { default: null },
    // false = the row doesn't tell whether the client exists now (no link shown)
    clientKnown: { type: Boolean, default: true },
  },
  computed: {
    hasCurrent() {
      return this.currentClientId != null && this.currentClientId !== ''
    },
  },
}
</script>

<style scoped lang="scss">
.bk-cref {
  line-height: 1.25;
  &__name { font-weight: 700; }
  &__name a { color: #7367f0; }
  &__sub { display: flex; align-items: center; gap: 0.35rem; margin-top: 0.1rem; }
  &__missing {
    border: 1px dashed rgba(255, 159, 67, 0.7); background: rgba(255, 159, 67, 0.08); color: #e8862a;
    font-size: 0.68rem; font-weight: 700; padding: 0.05rem 0.4rem; border-radius: 6px; cursor: pointer;
    &:hover { background: rgba(255, 159, 67, 0.2); }
  }
}
</style>
